import * as ng from 'angular';
import * as uib from 'angular-ui-bootstrap';
import * as _ from 'underscore';

export interface ModalSelectorDelegate {
   load(search:string):ng.IPromise<{total:number, list:any[]}>;
   title:string;
   multiSelect:boolean;
   templateUrl:string;
   extraSearchUrl?:string;
   parent?:ModalSelectorController;
   onClearSelection?();
}

export class ModalSelectorController {
   modalInstance:uib.IModalInstanceService;

   resolve:{
      selected:number[],
      delegate:ModalSelectorDelegate
   };

   isBusy:boolean;
   limit:number = 15;
   selectedIds:number[] = [];
   model:{total:number, list:any[]};
   list:any[];

   private _page:number = 1;
   private _search:string;

   $onInit() {
      if (this.resolve.selected) {
         // copy incoming array so we can modify it without changing callers array
         this.selectedIds = ng.copy(this.resolve.selected);
      }

      this.resolve.delegate.parent = this;

      this.reload();
   }

   get delegate() { return this.resolve.delegate; }

   get title():string { return this.delegate.title; }
   get multiSelect():boolean { return this.delegate.multiSelect; }
   get templateUrl():string { return this.delegate.templateUrl; }
   get extraSearchUrl():string { return this.delegate.extraSearchUrl; }

   get page():number { return this._page; }
   set page(val:number) {
      this._page = val;
      this.applyPaging();
   }

   get search():string { return this._search; }
   set search(val:string) {
      this._search = val;
      this.reload();
   }

   reload() {
      this.isBusy = true;
      this.delegate.load(this.search)
         .finally(() => this.isBusy = false)
         .then(model => {
            this.model = model;
            this.applyPaging();
         });
   }

   private applyPaging() {
      let offset = (this.page - 1) * this.limit;
      this.list = _.first(_.rest(this.model.list, offset), this.limit);
   }

   isSelected(row):boolean {
      return _.contains(this.selectedIds, row.id);
   }

   select(row) {
      if (!this.delegate.multiSelect) {
         this.modalInstance.close(row);
      } else {
         if (_.contains(this.selectedIds, row.id)) {
            this.selectedIds = _.without(this.selectedIds, row.id);
         } else {
            this.selectedIds.push(row.id);
         }
      }
   }

   hasSelected():boolean {
      return this.selectedIds.length > 0;
   }

   cancel() {
      this.modalInstance.dismiss('cancel');
   }

   clear() {
      if (this.multiSelect) {
         this.selectedIds = [];
         if (this.delegate.onClearSelection) {
            this.delegate.onClearSelection();
         }
      } else {
         this.modalInstance.close(null);
      }
   }

   done() {
      if (this.hasSelected()) {
         this.modalInstance.close(this.selectedIds);
      } else {
         this.modalInstance.close(null);
      }
   }
}

ng.module('e360').component('modalSelector', {
   templateUrl: require('./modal-selector.component.html'),
   controller: ModalSelectorController,
   bindings: {
      modalInstance: '<',
      resolve: '<'
   }
});
